import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Button, ProgressIndicator, ErrorBanner, ReduxControls } from 'rhombus-react';
import { initialize, reduxForm, reset, Field } from "redux-form";

import { CREATE_IMPOSIUM_PROJECT_FORM } from "widgets/forms/list";
import BasicModal from "widgets/modals/BasicModal";
import { closeModal } from "reducers/Modal";
import { createImposiumProject, clearImposiumErrors } from "reducers/ImposiumProjects";
import { Assets } from "reducers/Assets";

import useCancelToken from "hooks/useCancelToken";
import { requiredNotNull } from "widgets/forms/validators/validators";

import CompositionFields, { IMPOSIUM_COMPOSITION_DEFAULT_FORM_VALUES, compositionFormValuesToPostData } from "widgets/modals/imposium/CompositionFields";


import "./CreateImposiumProjectModal.css";


export function CreateImposiumProjectModal(props){
	const dispatch = useDispatch();

	const { handleSubmit, invalid } = props;

	const {
		libraryId,
		isSaving,
		errorObj,
	} = useSelector((state) => {
		return {
			libraryId: state.libraryProperties.id,
			isSaving: state.imposiumProjects.isSaving,
			errorObj: state.imposiumProjects.error || {},
		};
	});
	const { getNewToken } = useCancelToken(true);

	function onClose(){
		dispatch(reset(CREATE_IMPOSIUM_PROJECT_FORM));
		dispatch(closeModal());
	}

	const submitImposiumProject = (handleSubmit((values) => {
		let postData = {
			projectName: values.projectName,
			defaultComposition: compositionFormValuesToPostData(values.defaultCompositionName, values.defaultComposition),
		};

		dispatch(createImposiumProject(libraryId, postData)).then((resp) => {
			if (resp.success) {
				dispatch(Assets.clearAssets()).then(() => {
					dispatch(Assets.loadAssets(libraryId, getNewToken(), { excludeSubTypes: ["QR"]}));
					onClose();
				});
			}
		});
	}));


	useEffect(() => {
		dispatch(clearImposiumErrors());
		dispatch(initialize(CREATE_IMPOSIUM_PROJECT_FORM, {
			defaultComposition: IMPOSIUM_COMPOSITION_DEFAULT_FORM_VALUES,
		}));
	}, []);

	function renderContent(){
		return (
			<form id={CREATE_IMPOSIUM_PROJECT_FORM} onSubmit={submitImposiumProject}>
				<ProgressIndicator key="loading" isLoading={isSaving} />
				{ !!Object.keys(errorObj)?.length && <ErrorBanner
					title="Sorry, please fix the errors below and try again."
					messages={[errorObj.description]} />
				}
				<Field
					name="projectName"
					className="project-name"
					label="Project Name"
					required
					validate={[requiredNotNull]}
					component={ReduxControls.Input}
				/>
				<Field
					name="defaultCompositionName"
					className="default-composition-name"
					label="Default Composition Name"
					required
					validate={[requiredNotNull]}
					component={ReduxControls.Input}
				/>
				<CompositionFields formName={CREATE_IMPOSIUM_PROJECT_FORM} name={'defaultComposition'} />
			</form>
		);
	}

	function renderFooter(){
		return ([
			<Button key="back" theme="default" onClick={onClose}>Back</Button>,
			<Button
				key="create"
				disabled={isSaving || invalid}
				type="submit"
				theme="green"
				form={CREATE_IMPOSIUM_PROJECT_FORM}>
				Create
			</Button>
		]);
	}

	const modalProps = {
		title: `Create Imposium Project`,
		className: "create-imposium-project-modal",
		onClose,
		renderContent,
		renderFooter,
	};

	return <BasicModal {...modalProps} />;
}

CreateImposiumProjectModal.displayName = "CreateImposiumProjectModal";


export default reduxForm({
	form: CREATE_IMPOSIUM_PROJECT_FORM,
})(CreateImposiumProjectModal);
